
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 140 140"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M70 0a71.4 71.4 0 00-49.758 21.292A69.125 69.125 0 000 71.225 68.717 68.717 0 0068.833 140H70a70.642 70.642 0 0070-71.225A68.658 68.658 0 0070 0zm-8.75 96.483A8.633 8.633 0 0170 87.5a8.925 8.925 0 018.867 8.575A8.575 8.575 0 0170.292 105a8.925 8.925 0 01-9.042-8.517zm2.917-23.333v-35a5.833 5.833 0 0111.666 0v35a5.833 5.833 0 01-11.666 0z","fill":"currentColor"}})])
          )
        }
      }
    